<template>
  <div class="article-detail-page">
    <div v-if="loading" class="loading-state">
      Loading article content...
    </div>
    
    <div v-else-if="article">
      <section class="hero">
        <div class="container">
          <div class="hero-content">
            <h1>{{ article.title }}</h1>
          </div>
        </div>
      </section>

      <section class="article-content">
        <div class="container">
          <div class="article-body">
            <div class="article-image" v-if="article.imageSrc">
              <img :src="getImage(article.imageSrc)" :alt="article.title" />
            </div>
            
            <div class="article-text" v-html="article.content"></div>
            
            <div class="back-to-articles">
              <button class="back-button" @click="goBack">← Back to Articles</button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div v-else class="error-state">
      <p>Article not found.</p>
      <div class="back-to-articles">
        <button class="back-button" @click="goBack">← Back to Articles</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ArticleDetailPage',
  data() {
    return {
      article: null,
      loading: true
    };
  },
  mounted() {
    this.fetchArticle();
  },
  methods: {
    async fetchArticle() {
      const articleId = this.$route.params.id;
      try {
        const response = await axios.get(`/api/article/${articleId}`);
        this.article = response.data;
      } catch (error) {
        console.error('Failed to fetch article details:', error);
      } finally {
        this.loading = false;
      }
    },
    getImage(srcString){
      if (!srcString) return '';
      if (srcString.startsWith('/api/') || srcString.startsWith('http')) {
        return srcString;
      }
      const fileName = srcString.split('/').pop(); // Extract filename
      try{
        return require(`@/assets/images/${fileName}`);
      }
      catch(e){
        return srcString;
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.loading-state, .error-state {
  padding: 10rem 0;
  text-align: center;
  font-size: 1.5rem;
  color: white;
  min-height: 50vh;
  background-color: #151414;
}

.hero {
  background-image: url('@/assets/images/articles-hero.jpg');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 8rem 0;
  text-align: center;
  position: relative;
  width: 100%;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(8, 8, 8, 0.6);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  padding: 0 1rem;
}

.hero h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  line-height: 1.3;
}

.article-content {
  background-color: #151414;
  color: white;
  padding: 4rem 0;
  width: 100%;
}

.article-body {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1.5rem;
  width: 100%;
}

.article-image {
  margin-bottom: 2.5rem;
  text-align: center;
}

.article-image img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.article-text {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #e0e0e0;
  text-align: left;
}

.article-text p {
  margin-bottom: 4rem;
  padding-top: 1rem;
  text-align: left;
  font-size: 1.2rem;
}

.back-to-articles {
  margin-top: 3rem;
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid #7a7575;
}

.back-button {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: var(--secondary-color);
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 2rem;
  }
  
  .meta {
    font-size: 1rem;
  }
  
  .article-body {
    padding: 0 1rem;
  }
  
  .article-text {
    font-size: 1rem;
  }
}
</style>